import axios from '@/api/config';

const goodsInfoCenter = {
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfoCenter/pageList`, data);
  },
}

export default goodsInfoCenter;



// WEBPACK FOOTER //
// ./src/api/goodsInfoCenter.js